const HASH_STRING = 'Hello from IPFS Gateway Checker'
const HASH_TO_TEST = 'bafybeifx7yeb55armcsxwwitkymga5xf53dxiarykms3ygqic223w5sk3m'
const IMG_HASH = 'bafybeibwzifw52ttrkqlikfzext5akxu7lz4xiwjgwzmqcpdzmp3n5vnbe' // 1x1.png
// const IFRAME_HASH = 'bafkreifx3g6bkkwl7b4v43lvcqfo5vshbiehuvmpky2zayhfpg5qj7y3ca'
const IPNS_PATH_TO_TEST = '/ipns/en.wikipedia-on-ipfs.org/favicon.ico'
const TRUSTLESS_RESPONSE_TYPES = ['raw', 'car']
const DEFAULT_IPFS_GATEWAY = 'https://ipfs.io'

// Delay before starting CORS/IPNS/Origin/Trustless tests (in ms).
// Hotlink test runs immediately to provide fast visual feedback.
const SLOW_TESTS_DELAY = 3000

export {
  DEFAULT_IPFS_GATEWAY,
  HASH_STRING,
  HASH_TO_TEST,
  // IFRAME_HASH,
  IMG_HASH,
  IPNS_PATH_TO_TEST,
  SLOW_TESTS_DELAY,
  TRUSTLESS_RESPONSE_TYPES
}
